import { render } from "./ParamPortPageList.vue?vue&type=template&id=11ff05b4&scoped=true&ts=true"
import script from "./ParamPortPageList.vue?vue&type=script&lang=ts"
export * from "./ParamPortPageList.vue?vue&type=script&lang=ts"

import "./ParamPortPageList.vue?vue&type=style&index=0&id=11ff05b4&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ff05b4"]])

export default __exports__